import ClearFilterButton from './ClearFilterButton';

export default ClearFilterButton;
